import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/PageLayout';

const NotFound = () => {
  return (
    <PageLayout
      title="404 - Page Not Found"
      description="The page you're looking for doesn't exist"
      variant="default"
      showBookCallButton={false}
    >
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-white rounded-lg shadow-sm p-12">
          {/* Large 404 Number */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-terrapin-blue opacity-50">404</h1>
          </div>

          {/* Error Message */}
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Oops! Page Not Found</h2>
            <p className="text-lg text-gray-600 mb-6">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <p className="text-gray-500">
              Don't worry, it happens to the best of us. Let's get you back on track.
            </p>
          </div>

          {/* Navigation Options */}
          <div className="space-y-6">
            {/* Primary Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/" 
                className="btn-base btn-primary"
              >
                Go to Homepage
              </Link>
              <Link 
                to="/contact" 
                className="btn-base btn-secondary"
              >
                Contact Us
              </Link>
            </div>

            {/* Quick Links */}
            <div className="pt-8 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Or try one of these popular pages:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <Link 
                  to="/services" 
                  className="block p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group"
                >
                  <h4 className="font-medium text-terrapin-blue group-hover:text-terrapin-red transition-colors">
                    Our Services
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    Technology solutions for your business
                  </p>
                </Link>

                <Link 
                  to="/help-desk" 
                  className="block p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group"
                >
                  <h4 className="font-medium text-terrapin-blue group-hover:text-terrapin-red transition-colors">
                    Help Desk
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    Get technical support
                  </p>
                </Link>

                <Link 
                  to="/our-story" 
                  className="block p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group"
                >
                  <h4 className="font-medium text-terrapin-blue group-hover:text-terrapin-red transition-colors">
                    Our Story
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    Learn about Terrapin Networks
                  </p>
                </Link>

                <Link 
                  to="/our-team" 
                  className="block p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group"
                >
                  <h4 className="font-medium text-terrapin-blue group-hover:text-terrapin-red transition-colors">
                    Our Team
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    Meet our experts
                  </p>
                </Link>

                <Link 
                  to="/media" 
                  className="block p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group"
                >
                  <h4 className="font-medium text-terrapin-blue group-hover:text-terrapin-red transition-colors">
                    Media
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    News and updates
                  </p>
                </Link>

                <Link 
                  to="/contact" 
                  className="block p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group"
                >
                  <h4 className="font-medium text-terrapin-blue group-hover:text-terrapin-red transition-colors">
                    Contact Us
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    Get in touch with our team
                  </p>
                </Link>
              </div>
            </div>

            {/* Search Suggestion */}
            <div className="pt-6">
              <p className="text-gray-500 text-sm">
                Looking for something specific? 
                <Link to="/contact" className="text-terrapin-blue hover:text-terrapin-red font-medium ml-1">
                  Contact us
                </Link> and we'll help you find it.
              </p>
            </div>

            {/* Fun Element */}
            <div className="pt-6">
              <div className="inline-flex items-center space-x-2 text-gray-400">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">Made with care in Traverse City, MI</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default NotFound; 